<template>
  <v-container
    v-if="Object.entries(selectedSurvey).length !== 0"
    text-center
  >
    <h3>Filtering Options</h3>
    <v-row>
      <v-col
        v-for="(questionsOptions, questionName) in metaData.dynamicOptions"
        :key="questionName"
        :cols="setBreakpoint(questionsOptions, questionName)"
      >
        <v-card class="card">
          <v-card-title
            class="justify-center"
          >
            {{ metaData[questionName] }}
          </v-card-title>
          <v-row
            v-if="metaData.questionFilteringInputType[questionName] === 'switch'"
          >
            <v-col
              v-for="(text, index) in metaData.dynamicOptions[questionName]"
              :key="text"
            >
              <v-switch
                :label="text"
                :value="text"
                inset
                @change="
                  updateFilters({ inputType: 'switch', answerString: text, answerValue: index, questionName: questionName, toggled: $event !== null })
                "
              />
            </v-col>
          </v-row>
          <v-row
            v-else-if="metaData.questionFilteringInputType[questionName] === 'select'"
          >
            <v-col>
              <v-select
                v-model="metaData.dynamicFilterOptions[questionName]"
                :items="metaData.dynamicOptions[questionName]"
                return-object
                multiple
                @change="checkIfFiltering()"
              />
            </v-col>
          </v-row>
          <v-row
            v-else-if="metaData.questionFilteringInputType[questionName] === 'checkbox'"
          >
            <v-col
              v-for="(text, index) in metaData.dynamicOptions[questionName]"
              :key="text"
            >
              <v-checkbox
                :label="text"
                :value="text"
                @change="
                  updateFilters({ inputType: 'checkbox', answerString: text, answerValue: index, questionName: questionName, toggled: $event !== null })
                "
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    metaData: {type: Object, default: () => {}}
  },
  computed: {
    ...mapState({
      selectedSurvey: state => state.survey.selectedSurvey
    }),
  },
  methods: {
    ...mapActions("surveyResponseFiltering", [
      "setFilter",
      "updateSelectedFilterOptions"
    ]),
    setBreakpoint(questionsOptions, questionName) {
      if (this.$vuetify.breakpoint.xl || this.$vuetify.breakpoint.lg) {
        return this.metaData.questionFilteringFlexBoxSize[questionName];
      } else {
        return "12";
      }
    },
    updateFilters(params) {
      if (params.inputType === "checkbox" || params.inputType === "switch") {
        if (this.metaData.returnStringValue.includes(params.questionName)) {
          this.addOrRemoveStringValue(params.toggled, params.questionName, params.answerString);
        } else {
          this.addOrRemoveIndexValue(params.toggled, params.questionName, params.answerValue);
        }
      }
      this.checkIfFiltering();
    },
    addOrRemoveStringValue(adding, questionName, answerString) {
      if (adding) {
        this.metaData.dynamicFilterOptions[questionName].push(answerString);
      } else {
        this.metaData.dynamicFilterOptions[questionName] = this.metaData.dynamicFilterOptions[
          questionName
        ].filter(i => i !== answerString);
      }
    },
    addOrRemoveIndexValue(adding, questionName, answerValue) {
      if (adding) {
        this.metaData.dynamicFilterOptions[questionName].push(answerValue + 1)
      } else {
        this.metaData.dynamicFilterOptions[questionName] = this.metaData.dynamicFilterOptions[
          questionName
        ].filter(i => i !== answerValue + 1)
      }
    },
    checkIfFiltering() {
      let values = Object.values(this.metaData.dynamicFilterOptions);
      this.setFilter(false);
      values.forEach(filters => {
        if (filters.length > 0) {
          this.setFilter(true);
        }
      });
      this.updateSelectedFilterOptions(this.metaData.dynamicFilterOptions);
    }
  }
};
</script>

<style scoped>
.v-input--switch{
  justify-content: center
}
.card{
  height: 100%;
  padding: 1%;
}
.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>